const cleanApolloCache = (cache) => {
  cache.evict({ id: 'ROOT_MUTATION' });
  cache.gc();
};

export default cleanApolloCache;
